import { render, staticRenderFns } from "./LinkingDisticts.vue?vue&type=template&id=31032376&scoped=true&"
import script from "./LinkingDisticts.vue?vue&type=script&lang=js&"
export * from "./LinkingDisticts.vue?vue&type=script&lang=js&"
import style0 from "./LinkingDisticts.vue?vue&type=style&index=0&id=31032376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31032376",
  null
  
)

export default component.exports